/**
 * Availability API – all player availability read/write via Cloud Functions.
 * No direct Firestore access.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';
import { getActAsUserId } from '../impersonationStore';

const functions = getFunctions(app, 'us-central1');

function call(name, data = {}) {
  const fn = httpsCallable(functions, name);
  const actAs = getActAsUserId();
  const payload = actAs ? { ...data, actAsUserId: actAs } : data;
  return fn(payload).then((res) => res.data);
}

/** Get availability for one player in a tournament. */
export async function getPlayerAvailability(tournamentId, playerId) {
  const res = await call('availabilityGetPlayer', { tournamentId, playerId });
  return res?.availability ?? null;
}

/** Save availability for one player in a tournament. */
export async function savePlayerAvailability(tournamentId, playerId, data) {
  await call('availabilitySave', { tournamentId, playerId, data });
}

/** Add exclusion date (e.g. calendar decline). Pass matchId when caller has match access. */
export async function addExclusionDateForPlayer(tournamentId, playerId, dateKey, matchId) {
  await call('availabilityAddExclusion', {
    tournamentId,
    playerId,
    dateKey,
    matchId: matchId || undefined,
  });
}

/** Get all availability records for a player across tournaments. */
export async function getAllPlayerAvailability(playerId) {
  const res = await call('availabilityGetAllForPlayer', { playerId });
  return res?.list ?? [];
}

/** Get availability for multiple players in a tournament. Returns Map(playerId -> availability). */
export async function getAvailabilityForPlayers(tournamentId, playerIds) {
  const res = await call('availabilityGetForPlayers', { tournamentId, playerIds });
  const obj = res?.availability ?? {};
  return new Map(Object.entries(obj));
}
